import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcFavoriteH72(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "72",
    height: "72",
    fill: "none",
    viewBox: "0 0 72 72",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M48.252 9C58.054 9 66 16.961 66 26.777c0 5.104-2.34 9.377-5.282 12.639l-.003-.003c-1.563 1.83-6.73 7.047-11.707 11.97-5.046 4.992-10.137 9.928-11.403 11.025-.913.79-2.268.79-3.181 0-1.265-1.096-6.364-6.03-11.417-11.021-4.984-4.924-10.159-10.144-11.722-11.974C8.342 36.151 6.001 31.881 6 26.777 6 16.961 13.95 9 23.751 9c4.752 0 9.066 1.876 12.249 4.919A17.68 17.68 0 0 1 48.252 9"
  }));
}
var IcFavoriteH72 = createNolIcon(/*#__PURE__*/forwardRef(SvgIcFavoriteH72));

export { IcFavoriteH72 as I };
